<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            @if (isLoaded) {
            <truncate-text fxFlex="100" [allowHtml]="true" [mainText]="department()"
                class="forge-typography--subheading1">
            </truncate-text>
            }
        </div>

        @if (isLoaded && chartHasData) {
        <div slot="end" style="text-align: right; margin-right: 2em;">
            <span class="forge-typography--heading2">Ordered total:</span> {{total}}
        </div>
        }

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
            telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        @if (isLoaded) {
        <div>
            @if (showChart()) {
            <chartjs-container [config]="chartConfig">
            </chartjs-container>
            }
            @if (!chartHasData) {
            <div>Not enough data to display graph</div>
            }
        </div>
        }

        @else {
        <busy-indicator [chart]="true"></busy-indicator>
        }
    </div>
</forge-card>